import AppError from "../utils/AppError.js";
import getMessage from "../utils/getMessage.js";
import validator from "validator";

export const passwordValidator = (password) => {
  if (typeof password !== "string") {
    throw new AppError(
      400,
      getMessage("common", "invalidType", "eng", "Password", "string"),
    );
  }
  const trimmedPassword = password.trim();
  if (trimmedPassword.length < 8) {
    throw new AppError(
      400,
      getMessage("common", "lenTooShort", "eng", "password", 8),
    );
  }
  if (trimmedPassword.length > 20) {
    throw new AppError(
      400,
      getMessage("common", "lenExceeded", "eng", "password", 20),
    );
  }
  if (!validator.isStrongPassword(trimmedPassword)) {
    throw new AppError(400, getMessage("validator", "weakPassword"));
  }
};

export const OTPValidator = (otp) => {
  if (!otp) {
    throw new AppError(
      400,
      getMessage("common", "fieldRequired", "eng", "OTP"),
    );
  }
  if (typeof otp !== "string") {
    throw new AppError(
      400,
      getMessage("common", "invalidType", "eng", "otp", "string"),
    );
  }
  const trimmedOTP = otp.trim();
  if (trimmedOTP.length < 6) {
    throw new AppError(
      400,
      getMessage("common", "lenTooShort", "eng", "otp", 6),
    );
  }
  if (trimmedOTP.length > 6) {
    throw new AppError(
      400,
      getMessage("common", "lenExceeded", "eng", "otp", 6),
    );
  }
  if (!/^[0-9]*$/.test(trimmedOTP)) {
    throw new AppError(400, getMessage("common", "invalidInput", "eng", "otp"));
  }
};
